import React, { useState } from "react";
import "../styles/TeacherDownloadPage.css";
import TeacherStudentHeader from "../components/TeacherStudentHeader";
import TeacherDownload from "../components/TeacherDownload";
import Tutorials from "../components/Tutorials";
import TeacherFeedback from "../components/TeacherFeedback";
// import { teacherDownloadMenuItems } from "../components/TeacherMenuItems";
import  { teacherMenuItems, teacherDownloadMenuItems } from "../components/TeacherMenuItems";
const TeacherDownloadPage = () => {
  const [activeItem, setActiveItem] = useState("Download"); // Default to "Download" page
  const [isVideoMode, setIsVideoMode] = useState(true); // Default is the download page
  const [searchQuery, setSearchQuery] = useState("");

  // Removed unused resetSearch function

  const toggleMode = (mode) => {
    setIsVideoMode(mode);
  };

  const handleActiveItemChange = (item) => {
    setActiveItem(item); // Now updates activeItem state
    setSearchQuery(""); // Reset search whenever a new section is selected
    if (item === "home" || item === "") {
      // Navigate to home page
      window.location.href = "/teacher";
    } else if (item === "feedback") {
      // Navigate to feedback page
      window.location.href = "/teacherFeedback";
    } else if (item === "Download") {
      // Navigate to download page
      window.location.href = "/teacher/download";
    }
  };

  // Determine which parts of the header to show based on the active menu item
  const getHeaderVisibility = () => {
    if (activeItem === "feedback") {
      return { showSearch: false, showToggle: false, showUserProfile: true };
    } else if (activeItem === "tutorials") {
      return { showSearch: true, showToggle: false, showUserProfile: true };
    }
    return { showSearch: false, showToggle: false, showUserProfile: true };
  };

  const renderContent = () => {
    if (activeItem === "Download" || activeItem === "") {
      return isVideoMode ? <TeacherDownload /> : <TeacherDownload />;
    } else if (activeItem === "feedback") {
      return <TeacherFeedback />;
    } else if (activeItem === "tutorials") {
      return <Tutorials searchQuery={searchQuery} />;
    } else {
      return <div>Loading...</div>;
    }
  };
  const { showSearch, showToggle, showUserProfile } = getHeaderVisibility();

  return (
    <div className="dashboard">
      {/* <Header
        isVideoMode={isVideoMode}
        toggleMode={toggleMode}
        showSearch={showSearch}
        showToggle={showToggle}
        showUserProfile={showUserProfile}
      /> */}

      <TeacherStudentHeader
        isVideoMode={isVideoMode}
        toggleMode={toggleMode}
        showSearch={showSearch}
        showToggle={showToggle}
        showUserProfile={showUserProfile}
        teacherMenuItems={teacherMenuItems}
        activeItem={activeItem}
        setActiveItem={handleActiveItemChange}
      />

      <main className="main-content">
        {/* <Sidebar
          activeItem={activeItem}
          setActiveItem={setActiveItem}
          menuItems={teacherMenuItems}
          resetSearch={resetSearch}
        /> */}
        <div className="content">{renderContent()}</div>
      </main>
    </div>
  );
};

export default TeacherDownloadPage;
